import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps"

const StyledGoogleMaps = styled.div`
  padding: 2rem 0;

  @media (min-width: 769px) {
    padding: 5rem 0;
  }
`

const GoogleMaps = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={8}
      defaultCenter={{ lat: props.lat, lng: props.lon }}
    >
      <Marker position={{ lat: props.lat, lng: props.lon }} />
    </GoogleMap>
  )),
)

const GoogleMapsComponent = ({ lon = "", lat = "" }) => {
  return (
    <StyledGoogleMaps>
      <GoogleMaps
        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `450px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        lat={lat}
        lon={lon}
      />
    </StyledGoogleMaps>
  )
}

GoogleMapsComponent.propTypes = {
  lon: PropTypes.string,
  lat: PropTypes.string,
}

export default GoogleMapsComponent
